const toDate = (value) => {
  if (!value) return null;

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const addDays = (date, daysToAdd) => {
  const next = new Date(date);
  next.setDate(next.getDate() + daysToAdd);
  return next;
};

export const formatSubscriptionDate = (dateStr) => {
  if (!dateStr) return "N/A";

  const parsed = new Date(dateStr);
  if (Number.isNaN(parsed.getTime())) return dateStr;

  return parsed.toLocaleDateString("en-AU", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const getSubscriptionIntervalKey = (subscription = {}) => {
  const parts = [
    subscription?.plan_name,
    subscription?.subscription_plan,
    subscription?.plan,
    subscription?.plan_key,
    subscription?.price_plan,
    subscription?.interval,
    subscription?.billing_interval,
    subscription?.billingInterval,
    subscription?.period,
    subscription?.cycle,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  if (parts.includes("year")) return "yearly";
  if (parts.includes("month")) return "monthly";
  return "";
};

export const getPlanExpiryDate = (subscription = {}) => {
  if (subscription?.plan_expiry_date) return subscription.plan_expiry_date;

  const interval = getSubscriptionIntervalKey(subscription);
  if (interval !== "monthly" && interval !== "yearly") return null;

  const daysLeftNumber = Number(subscription?.days_left ?? 0);
  const trialEndDate = toDate(subscription?.trial_end_date);
  const fallbackTrialEnd = addDays(new Date(), Math.max(daysLeftNumber, 0));
  const startDate = trialEndDate || fallbackTrialEnd;
  const planDays = interval === "yearly" ? 365 : 30;

  return addDays(startDate, planDays);
};
